export const TEST_ID = 'tabPanelBatteryFirmware';
